import React, {useEffect, useState} from "react"
import {useAuth0} from "@auth0/auth0-react"
import Loader from "../../components/loader/Loader"
import {useDispatch} from "../../store"
import {updateToken} from "./authSlice"

interface AuthProviderProps {
    children: React.ReactNode
}

const AuthProvider: React.FC<AuthProviderProps> = ({children}) => {
    const [loading, setLoading] = useState(true)
    const dispatch = useDispatch()
    const {getAccessTokenSilently, isAuthenticated} = useAuth0()

    useEffect(() => {
        if (!isAuthenticated) {
            setLoading(false)
            return
        }

        let cancelled = false

        getAccessTokenSilently({detailedResponse: true})
            .then(response => {
                if (!cancelled) {
                    dispatch(updateToken({token: response.access_token, expires: response.expires_in}))
                    setLoading(false)
                }
            })
            .catch(error => {
                console.error("Failed to get access token silently:", error)
                if (!cancelled) {
                    setLoading(false)
                }
            })

        return () => {
            cancelled = true
        }
    }, [getAccessTokenSilently, isAuthenticated, dispatch])

    if (loading) return <Loader>Загрузка...</Loader>

    return <>{children}</>
}

export default AuthProvider
